import { GET_FILTER } from "../constants";

export const filter = (state = { filterdata: [] }, action) => {
  switch (action.type) {
    case GET_FILTER:
      return { ...state, filterdata: action.filterdata };
    default:
      return state;
  }
};
